<div *ngIf="vouchers" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="150" (scrolled)="onScrolled()"
  class="row row-cols-2 row-cols-md-3 row-cols-xl-4 g-2 g-md-4">
  <div *ngFor="let x of vouchers | slice:0:page * itemsPerPage" class="col">
    <div class="card border-1">
      <a [routerLink]="['/carduri-cadou', x.slug]">
        <img class="card-img" [src]="x.image" [alt]="x.partnerName">
      </a>
    </div>
  </div>
</div>

<!-- Loading template -->
<div *ngIf="!vouchers" class="row row-cols-2 row-cols-md-3 row-cols-xl-4 g-2 g-md-4">
  <div *ngFor="let item of [].constructor(itemsPerPage); index as index" class="col">
    <div class="card border-2 bg-secondary" aria-hidden="true">
      <div class="card-header border-0 rounded-0 py-2 placeholder-glow">
        <span class="placeholder col-10"></span>
      </div>
      <div class="position-relative placeholder-glow">
        <div class="card-img border border-2 placeholder ratio ratio-16x9"></div>
        <i class="ai-image position-absolute top-50 start-50 translate-middle fs-1 opacity-50"></i>
      </div>
    </div>
  </div>
</div>
